import { NgModule, ErrorHandler } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { HttpClient } from '@angular/common/http'
import { appRoutes } from './app.routes'
import { AppComponent } from './app.component'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpRequestInterceptor } from './interceptor/http-request-interceptor'
import { PortalGlobals } from './portalglobals'
import { GlobalErrorHandler } from './global-error-handler'
//import { HomeModule } from '../app/home/home.module'
import { ExternalLayoutComponent } from './external-layout/external-layout.component'
import { InternalComponent } from './internal-layout/internal.component'
import { EAppBeneficiaryComponent } from './e-app-beneficiary/component/EAppBeneficiary.component'
import { EAppBeneficiaryModule } from './e-app-beneficiary/e-app-beneficiary.module'
// import {SOAViewEmailComponent} from '../app/electronic-soa/components/soa-view-email.component'
import { ElectrronicSOAModule } from '../app/electronic-soa/electronic-soa.modules'
import { ESOAFormComponent } from '../app/electronic-soa/components/ESOAFormComponent'
import { ESOAFormViewAgentSignedComponent } from '../app/electronic-soa/components/ESOAFormViewAgentSignedComponent'
import { ESOAFormReturnToAgentComponent } from '../app/electronic-soa/components/ESOAFormReturnToAgentComponent'
import { ESOAFormExpiredComponent } from '../app/electronic-soa/components/ESOAFormExpiredComponent'
import { ContactUsComponent } from '../app/contact/components/contact-us.component'
import { ContactusModule } from '../app/contact/contact.module'
import { CanActivateGaurd } from './auth/can-activate-gaurd'
import { UtilsService } from '../app/enrollment/components/common/utils-service'
import { ReportsModule } from '../app/reports/reports.module'
import { ManageNotificationsModule } from './manage-notifications/manage-notifications.module'
import { jqxCalendarModule } from 'jqwidgets-ng/jqxcalendar'
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist'
import { jqxInputModule } from 'jqwidgets-ng/jqxinput'
import { jqxLayoutModule } from 'jqwidgets-ng/jqxlayout'
import { jqxLinkButtonModule } from 'jqwidgets-ng/jqxlinkbutton'
import { jqxListBoxModule } from 'jqwidgets-ng/jqxlistbox'
import { jqxListMenuModule } from 'jqwidgets-ng/jqxlistmenu'
import { AuthService } from './auth/auth-service'

import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SessionWarningDialogComponent } from './sessionWarningDialog/session-warning-dialog.component'

@NgModule({
    imports: [
        FormsModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        EAppBeneficiaryModule,
        ElectrronicSOAModule,
        ContactusModule,
        // InternalModule,
        // TreeViewModule,
        //  EnrollmentModule,
        // HttpClientModule,
        jqxCalendarModule,
        jqxDropDownListModule,
        jqxInputModule,
        jqxLayoutModule,
        jqxLinkButtonModule,
        jqxListBoxModule,
        jqxListMenuModule,
        RouterModule.forRoot(appRoutes, { useHash: true }),
        
        NgIdleModule.forRoot(),          // Add NgIdleModule
        NgIdleKeepaliveModule.forRoot()

    ],
    declarations: [
        AppComponent,
        ExternalLayoutComponent,
        InternalComponent,
        EAppBeneficiaryComponent,
        // SOAViewEmailComponent,
        ESOAFormComponent,
        ESOAFormViewAgentSignedComponent,
        ESOAFormReturnToAgentComponent,
        ESOAFormExpiredComponent,
        ContactUsComponent,
        SessionWarningDialogComponent

        //jqx components
        //jqxBarGaugeComponent       ,
        //jqxBulletChartComponent    ,
        //jqxButtonGroupComponent    ,
        // jqxCalendarComponent,
        //jqxChartComponent          ,
        //jqxCheckBoxComponent       ,
        //jqxColorPickerComponent    ,
        //jqxComboBoxComponent       ,
        //jqxComplexInputComponent   ,
        //jqxDataTableComponent      ,
        //jqxDockingComponent        ,
        //jqxDockingLayoutComponent  ,
        //jqxDockPanelComponent      ,
        //jqxDragDropComponent       ,
        //jqxDrawComponent           ,
        // jqxDropDownListComponent,
        //jqxExpanderComponent       ,
        //jqxFormattedInputComponent ,
        //jqxGaugeComponent          ,
        // jqxInputComponent,
        //jqxKanbanComponent         ,
        //jqxKnobComponent           ,
        // jqxLayoutComponent,
        //jqxLinearGaugeComponent    ,
        // jqxLinkButtonComponent,
        // jqxListBoxComponent,
        // jqxListMenuComponent
        //jqxLoaderComponent         ,
        //jqxMaskedInputComponent    ,
        //jqxNavBarComponent         ,
        //jqxNotificationComponent   ,
        //jqxNumberInputComponent    ,
        //jqxPasswordInputComponent  ,
        //jqxPivotDesignerComponent  ,
        //jqxPivotGridComponent      ,
        //jqxPopoverComponent        ,
        //jqxProgressBarComponent    ,
        //jqxRadioButtonComponent    ,
        //jqxRangeSelectorComponent  ,
        //jqxRatingComponent         ,
        //jqxRepeatButtonComponent   ,
        //jqxResponsivePanelComponent,
        //jqxRibbonComponent         ,
        //jqxSchedulerComponent      ,
        //jqxScrollBarComponent      ,
        //jqxScrollViewComponent     ,
        //jqxSliderComponent         ,
        //jqxSplitterComponent       ,
        //jqxSwitchButtonComponent   ,
        //jqxTabsComponent           ,
        //jqxTagCloudComponent       ,
        //jqxTextAreaComponent       ,
        //jqxToggleButtonComponent   ,
        //jqxToolBarComponent        ,
        //jqxTooltipComponent        ,
        //jqxTreeMapComponent        ,
        //jqxValidatorComponent      ,
        //jqxWindowComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        { provide: CanActivateGaurd, useClass: CanActivateGaurd },
        { provide: PortalGlobals, useClass: PortalGlobals },
        //{ provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: UtilsService, useClass: UtilsService },
        { provide: AuthService, useClass: AuthService }
    ],
    exports: [RouterModule],

    bootstrap: [AppComponent]
})
export class AppModule {}
